import moment from 'moment';
import * as R from 'ramda';
import * as Promise from 'bluebird';

import specSheetImages from 'components/specSheetImages';
import { getLocalStorageInfo, setLocalStorageInfo, _toBlob } from '../../utils';

export const fileSystem = () => {
  const path = window.require('path');
  const remote = window.require('electron').remote;
  window.module.paths.push(path.resolve('./node_modules'));
  window.module.paths.push(path.join(remote.getGlobal('appPath'), 'node_modules'));
  const fs = remote.require('fs-extra');

  const userDataPath = remote.getGlobal('appDataPath');
  const appPath = remote.getGlobal('appPath');

  const documentsDirectory = userDataPath;
  const applicationDirectory = appPath;
  const databaseDirectory = path.join(userDataPath, 'databases/');

  const syncImageDirectoryEntry = path.join(documentsDirectory, 'sync-images');

  const imageDirectoryEntry = path.join(documentsDirectory, 'spec-sheet-images');

  const getImageUrl = url => {
    const path = window.require('path');

    let fileName = path.basename(url);

    return `cdvfile://localhost/persistent/spec-sheet-images/${fileName}`;
  };

  const chooseFile = fileExt =>
    new Promise((success, reject) => {
      var _chooseFileOk = files => {
        if (files) {
          let uri = files[0];

          setTimeout(function() {
            success(uri);
          }, 1000);
        } else {
          reject();
        }
      };

      const dialog = remote.dialog;
      const files = dialog.showOpenDialog({
        properties: ['openFile'],
        filters: [
          {
            name: '',
            extensions: [...fileExt],
          },
        ],
      });

      if (files && files.length > 0) {
        _chooseFileOk(files);
      }
    });

  const directoryReader = directory => ({
    localURL: directory,
    createReader: () => ({
      readEntries: cb => {
        fs.readdir(directory)
          .then(files => cb(R.map(file => ({ name: file }))(files)))
          .catch(error => {
            console.log(error);
          });
      },
    }),
  });

  const getSyncImageDirectory = () =>
    new Promise((success, reject) => {
      fs.mkdirs(syncImageDirectoryEntry)
        .then(() => {
          success(directoryReader(syncImageDirectoryEntry));
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const removeSyncImageDirectory = () => Promise.resolve(); //removeFile(syncImageDirectoryEntry);

  const getImageDirectory = () =>
    new Promise((success, reject) => {
      fs.mkdirs(imageDirectoryEntry)
        .then(() => {
          success(directoryReader(imageDirectoryEntry));
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const getDirectory = directory =>
    new Promise((success, reject) => {
      const directoryPath = path.join(applicationDirectory, directory);
      fs.mkdirs(directoryPath)
        .then(() => {
          success(directoryReader(directoryPath));
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const getBackupDirectory = () =>
    new Promise((success, reject) => {
      const backupDirectory = path.join(documentsDirectory, 'Backups');
      fs.mkdirs(backupDirectory)
        .then(() => {
          success(backupDirectory);
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const getRestoreDirectory = () =>
    new Promise((success, reject) => {
      let rootDirectory = documentsDirectory;
      let restoreDirectory = path.join(rootDirectory, 'Restore');
      fs.mkdirs(restoreDirectory)
        .then(() => {
          success(restoreDirectory);
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const cacheRestoreFile = fileUrl =>
    new Promise((success, reject) => {
      getRestoreDirectory().then(restoreDirectoryEntry => {
        let cachedFile = path.join(restoreDirectoryEntry, path.basename(fileUrl));
        fs.copy(fileUrl, cachedFile)
          .then(() => {
            success({ name: path.basename(fileUrl), url: cachedFile });
          })
          .catch(error => {
            console.log(error);
            reject();
          });
      });
    });

  const getBackupCacheDirectory = cacheDirectoryName =>
    new Promise((success, reject) => {
      const backupDirectory = path.join(documentsDirectory, 'Backups', cacheDirectoryName);
      fs.mkdirs(backupDirectory)
        .then(() => {
          success(backupDirectory);
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const getBackupImgDirectory = () =>
    new Promise((success, reject) => {
      const backupDirectory = path.join(documentsDirectory, 'spec-sheet-images');
      fs.mkdirs(backupDirectory)
        .then(() => {
          success(backupDirectory);
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const savebase64AsImageFile = (filename, content) =>
    new Promise((success, reject) => {
      // Convert the base64 string in a Blob
      let DataBlob = new Buffer(content, 'base64');

      console.log('Writing base64 file');

      let filePath = path.join(imageDirectoryEntry, filename);
      fs.writeFile(filePath, DataBlob)
        .then(() => {
          console.log(`${filename} copied`);
          success({ name: filename, url: `file://${filePath}` });
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const copyEmailBck = lang => savebase64AsImageFile('specsheet-print-' + lang + '.png', specSheetImages[lang]);

  const saveHtmlFile = (filename, content) =>
    new Promise((success, reject) => {
      console.log('Writing html file');

      const filePath = path.join(imageDirectoryEntry, filename);
      fs.writeFile(filePath, content)
        .then(() => {
          success({ name: filename, url: `file://${filePath}` });
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const saveLocalStorageInfoFile = (directoryEntry, content) =>
    new Promise((success, reject) => {
      console.log('Writing localStorage file');

      let filePath = path.join(directoryEntry, 'userLocalInfo.json');
      fs.writeFile(filePath, content)
        .then(() => {
          success({ name: 'userLocalInfo.json', url: `file://${filePath}` });
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const removeImageFile = filename =>
    new Promise(success => {
      console.log('remove image file');

      console.log('Access to the directory granted succesfully');
      fs.remove(path.join(imageDirectoryEntry, filename))
        .then(() => {
          success();
        })
        .catch(error => {
          console.log(error);
          alert('Unable to remove file in path');
          success();
        });
    });

  const removeFile = fileUrl =>
    new Promise((success, reject) => {
      console.log('remove file');

      console.log('Access to the directory granted succesfully');
      fs.remove(fileUrl)
        .then(() => {
          success();
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const readFile = file =>
    new Promise(success => {
      fs.readFile(file)
        .then(result => {
          success(result);
        })
        .catch(error => {
          console.log('error reading file');
          console.log(error);
          success();
        });
    });

  const readFileBlob = file =>
    new Promise(success => {
      readFile(file)
        .then(result => {
          const b = _toBlob(result);
          success(b);
        })
        .catch(error => {
          console.log(error);
          success();
        });
    });

  const getBackupFiles = () =>
    new Promise((success, reject) => {
      const backupDirectoryPath = path.join(documentsDirectory, 'Backups');
      let files = [];

      fs.readdir(backupDirectoryPath)
        .then(entries =>
          success(
            entries
              .filter(entry => entry.file && entry.name.indexOf('.zip') >= 0)
              .map(entry => ({
                localURL: entry.toNativeURL(),
                name: entry.name,
              }))
          )
        )
        .catch(reject);
    });

  const prepareBackup = databaseName =>
    new Promise((success, reject) => {
      const databaseFile = path.join(databaseDirectory, databaseName);
      const backupCacheDirectoryName = moment().format('YYYYMMDD-hhmmss');

      let userDataPath = window.require('electron').remote.getGlobal('appDataPath');

      const backupCacheDirectoryPath = path.join(userDataPath, 'Backups', backupCacheDirectoryName);
      const backupFileName = path.join(userDataPath, 'Backups', backupCacheDirectoryName + '.zip');

      getBackupCacheDirectory(backupCacheDirectoryName)
        .then(backupCacheDirectoryEntry => {
          return fs
            .copy(databaseFile, path.join(backupCacheDirectoryEntry, databaseName))
            .then(() => saveLocalStorageInfoFile(backupCacheDirectoryEntry, getLocalStorageInfo(databaseName)))
            .then(() => getBackupImgDirectory())
            .then(imageDirectoryEntry => fs.copy(imageDirectoryEntry, path.join(backupCacheDirectoryEntry, 'images')))
            .then(() => {
              success({ backupCacheDirectoryPath, backupFileName });
            })
            .catch(reject);
        })
        .catch(reject);
    });

  const zipSyncImages = imagesPath =>
    new Promise((success, reject) => {
      const syncImagesDirectoryPath = `${documentsDirectory}/sync-images`;
      const syncImagesZipFile = `${documentsDirectory}/sync-images.zip`;

      const Archiver = window.require('archiver');
      const destStream = fs.createWriteStream(syncImagesZipFile);
      const archive = Archiver('zip');

      const zipHandler = () => {
        console.log('Sync Images zipped');
        removeSyncImageDirectory()
          .then(() => {
            success(syncImagesZipFile, {
              remove: (success, errorCbk) => {
                removeFile(syncImagesZipFile)
                  .then(() => {
                    if (success) {
                      success();
                    }
                  })
                  .catch(err => {
                    if (errorCbk) {
                      errorCbk(err);
                    }
                  });
              },
              nativeURL: syncImagesZipFile,
            });
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      };

      const copyImageToSyncFolder = (imagePath, syncImagesDirectoryEntry) =>
        console.log(`${syncImagesDirectoryEntry}/${imagePath}`) ||
        fs.copy(`${documentsDirectory}/spec-sheet-images/${imagePath}`, `${syncImagesDirectoryEntry}/${imagePath}`);

      getSyncImageDirectory().then(syncImagesDirectoryEntry => {
        const copyFiles = imagesPath.map(imagePath =>
          copyImageToSyncFolder(imagePath, syncImagesDirectoryEntry.localURL)
        );

        Promise.all(copyFiles).then(() => {
          archive.on('progress', percent => {
            console.log('progress', ~~((percent.entries.processed / percent.entries.total) * 100));
          });

          destStream.on('close', function() {
            zipHandler();
          });

          archive.glob('**/*', {
            cwd: syncImagesDirectoryPath,
          });

          archive.pipe(destStream);
          archive.finalize();
        });
      });
    });

  const zipSyncImage = imagePath =>
    new Promise(success => {
      console.log('returning file path');
      const imageFullPath = `${documentsDirectory}/spec-sheet-images/${imagePath}`;
      success(imageFullPath);
      // fs.pathExists(imageFullPath).then(exists => {
      //   if (exists) {
      //     const syncImagesDirectoryPath = `${documentsDirectory}/sync-images`;
      //     const syncImagesZipFile = `${documentsDirectory}/sync-images/${imagePath}.zip`;

      //     const Archiver = window.require('archiver');
      //     const archive = Archiver('zip');

      //     const zipHandler = () => {
      //       console.log(`Sync Image ${imagePath} zipped`);
      //       success(syncImagesZipFile, {
      //         remove: (success, errorCbk) => {
      //           removeFile(syncImagesZipFile)
      //             .then(() => {
      //               if (success) {
      //                 success();
      //               }
      //             })
      //             .catch(err => {
      //               if (errorCbk) {
      //                 errorCbk(err);
      //               }
      //             });
      //         },
      //         nativeURL: syncImagesZipFile,
      //       });
      //     };

      //     const copyImageToSyncFolder = (imagePath, syncImagesDirectoryEntry) =>
      //       console.log(`copy image: ${syncImagesDirectoryEntry}/${imagePath}`) ||
      //       fs.copy(`${documentsDirectory}/spec-sheet-images/${imagePath}`, `${syncImagesDirectoryEntry}/${imagePath}`);

      //     getSyncImageDirectory().then(syncImagesDirectoryEntry => {
      //       const destStream = fs.createWriteStream(syncImagesZipFile);

      //       copyImageToSyncFolder(imagePath, syncImagesDirectoryEntry.localURL).then(() => {
      //         archive.on('progress', percent => {
      //           console.log('progress', ~~((percent.entries.processed / percent.entries.total) * 100));
      //         });

      //         destStream.on('close', function() {
      //           zipHandler();
      //         });

      //         archive.glob(imagePath, {
      //           cwd: syncImagesDirectoryPath,
      //         });

      //         archive.pipe(destStream);
      //         archive.finalize();
      //       });
      //     });
      //   } else {
      //     success();
      //   }
      // });
    });

  const removeSyncZipFile = () => {
    const fs = window.require('fs');

    removeFile(`${documentsDirectory}/sync-images.zip`);
  };

  const zipBackup = ({ backupCacheDirectoryPath, backupFileName }) =>
    new Promise((success, reject) => {
      const zipHandler = () => {
        console.log('backup saved', fs);
        removeFile(backupCacheDirectoryPath)
          .then(() => {
            success(backupFileName, {
              remove: (success, errorCbk) => {
                removeFile(backupFileName)
                  .then(() => {
                    if (success) {
                      success();
                    }
                  })
                  .catch(err => {
                    if (errorCbk) {
                      errorCbk(err);
                    }
                  });
              },
              nativeURL: backupFileName,
            });
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      };

      const fs = window.require('fs');
      const Archiver = window.require('archiver');
      const destStream = fs.createWriteStream(backupFileName);
      const archive = Archiver('zip');

      archive.on('progress', percent => {
        console.log('progress', ~~((percent.entries.processed / percent.entries.total) * 100));
      });

      destStream.on('close', function() {
        zipHandler();
      });

      archive.glob('**/*', {
        cwd: backupCacheDirectoryPath,
      });

      archive.pipe(destStream);
      archive.finalize();
    });

  const unzipRestore = restoreFilePath =>
    new Promise((success, reject) => {
      const userDataPath = window.require('electron').remote.getGlobal('appDataPath');

      let restoreFolder = restoreFilePath.replace('.zip', '');

      const dataDirectory = path.join(userDataPath, 'databases');
      const rootDirectory = userDataPath;

      const nZip = window.require('node-zip-dir');

      nZip
        .unzip(restoreFilePath, restoreFolder)
        .then(() => success({ dataDirectory, rootDirectory, restoreFolder }))
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });

  const restoreData = ({ dataDirectory, restoreFolder }) =>
    new Promise((success, reject) => {
      fs.readFile(path.join(restoreFolder, 'userLocalInfo.json'))
        .then(localStorageInfoString => {
          const localStorageInfo = JSON.parse(localStorageInfoString);
          const databaseName = localStorageInfo.databaseName;

          setLocalStorageInfo(localStorageInfoString);

          // copy database
          return fs.copy(path.join(restoreFolder, databaseName), path.join(dataDirectory, databaseName));
        })
        .then(success)
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const restoreImages = ({ rootDirectory, restoreFolder }) =>
    new Promise((success, reject) => {
      // copying images
      fs.copy(path.join(restoreFolder, 'images'), path.join(rootDirectory, 'spec-sheet-images'))
        .then(() => {
          success();
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });

  const saveFileToDropbox = (file, DROPBOX_APP_KEY) =>
    new Promise((success, fail) => {
      var _chooseFileOk = (saveDirectory, file) => {
        if (saveDirectory) {
          fs.copy(file, path.join(saveDirectory, path.basename(file)))
            .then(success)
            .catch(error => {
              console.log(error);
              fail();
            });
        } else {
          fail();
        }
      };

      const dialog = window.require('electron').remote.dialog;
      const saveDirectory = dialog.showOpenDialog({
        properties: ['openDirectory'],
      });

      if (saveDirectory && saveDirectory.length > 0) {
        _chooseFileOk(saveDirectory[0], file);
      } else {
        console.log('Save backup cancelled!');
        fail();
      }
    });

  const renameDatabase = (localDatabaseName, remoteDatabaseName) =>
    localDatabaseName !== remoteDatabaseName
      ? new Promise((success, reject) => {
          console.log(`Renaming database: ${localDatabaseName} to: ${remoteDatabaseName}`);
          const localDatabaseFile = path.join(databaseDirectory, localDatabaseName);
          const remoteDatabaseFile = path.join(databaseDirectory, remoteDatabaseName);

          fs.copy(localDatabaseFile, remoteDatabaseFile)
            .then(success)
            .catch(error => console.log(error) || success());
        })
      : Promise.resolve();

  const unzipFile = file =>
    new Promise((success, reject) => {
      const path = window.require('path');

      getImageDirectory().then(imageDirectoryReader => {
        const imageDirectoryUrl = imageDirectoryReader.localURL;
        const zipFilePath = path.join(imageDirectoryUrl, file);

        const nZip = window.require('node-zip-dir');

        nZip
          .unzip(zipFilePath, imageDirectoryUrl)
          .then(() => removeFile(zipFilePath).then(() => success()))
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    });

  return {
    getImageUrl,
    chooseFile,
    getImageDirectory,
    getDirectory,
    getBackupDirectory,
    getRestoreDirectory,
    cacheRestoreFile,
    getBackupCacheDirectory,
    getBackupImgDirectory,
    savebase64AsImageFile,
    copyEmailBck,
    saveHtmlFile,
    saveLocalStorageInfoFile,
    removeImageFile,
    removeFile,
    readFile,
    readFileBlob,
    getBackupFiles,
    prepareBackup,
    zipBackup,
    unzipRestore,
    restoreData,
    restoreImages,
    saveFileToDropbox,
    renameDatabase,
    zipSyncImages,
    zipSyncImage,
    removeSyncZipFile,
    removeSyncImageDirectory,
    unzipFile,
  };
};
